import { render, staticRenderFns } from "./Complementos.vue?vue&type=template&id=67be7e46&scoped=true"
import script from "./Complementos.vue?vue&type=script&lang=js"
export * from "./Complementos.vue?vue&type=script&lang=js"
import style0 from "./Complementos.vue?vue&type=style&index=0&id=67be7e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be7e46",
  null
  
)

export default component.exports